import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'Nossa tscherna',
  bestPriceBadge: 'Meglier pretsch',
  regulatedNotice: {
    prescriptionOnly: 'Mo cun recept',
    professionalUse: 'Diever professiunal',
    fromVeterinarian: 'Disponibel tar Voss veterinari',
    fromPharmacist: 'Disponibel tar in apotecher',
    noOnlinePurchase: 'Nagina vendita online',
    professionalSupply: 'Vendì tras furniturs professiunals',
    whyNoLink: 'Nus evaluain quest product, ma na mettain nagina colliaziun ad el.',
  },
};
